import { Box, Heading, Link, Paragraph } from '@/src/packages/components';
import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { ICertification } from '@/src/interfaces/generated/contentful';
import { TemplateSidebar } from '@/src/packages/components/templates/TemplateSidebar';
import { ManufacturingLinks } from '@/src/packages/components/ui/Footer/Footer.config';
import Image from 'next/image';
import NextLink from 'next/link';
import { getRoute } from '@/src/packages/utils/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { paths } from '@/src/packages/routes';

type ICertificationsIndexPageProps = {
  certifications: ICertification[];
};

export const CertificationListItem = ({
  certification,
}: {
  certification: ICertification;
}) => {
  return (
    <Box className="flex items-start gap-6">
      <Box className="relative aspect-square w-[100px] border">
        <Image
          src={certification.fields.logo.fields.file.url}
          alt={`${certification.fields.name} logo`}
          fill
          className="object-cover"
        />
      </Box>
      <Box className="flex-1 space-y-3">
        <Box className="space-y-3">
          <Heading as="h2" className="text-lg font-medium leading-none">
            {certification.fields.name}
          </Heading>
          <Paragraph className="max-w-2xl">
            {certification.fields.description}
          </Paragraph>
        </Box>

        <Link className="inline-block" variant="solid">
          <NextLink
            href={getRoute({
              route: paths.CERTIFICATIONS_SINGLE,
              params: { [pathParams.SLUG]: certification.fields.slug },
            })}
          >
            Learn more
          </NextLink>
        </Link>
      </Box>
    </Box>
  );
};

export const CertificationsIndexPage = (
  props: ICertificationsIndexPageProps,
) => {
  const { certifications } = props;

  return (
    <TemplateSidebar title="Certifications" links={ManufacturingLinks}>
      <PageSectionStack>
        <Paragraph className="max-w-2xl" size="lead">
          When it comes to our manufactiring processes, we are committed to
          ensuring they meet the standards we have set for ourselves.
          Third-party certifications play an important role in helping us ensure
          that these standards are met by our manufacturing partners. These are
          some of the certifiying bodies involved in this process.
        </Paragraph>

        {certifications.map((certification, i) => {
          return (
            <CertificationListItem key={i} certification={certification} />
          );
        })}
      </PageSectionStack>
    </TemplateSidebar>
  );
};
